// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__kMjGs","title":"InfoRow_title__2Y7G0"};